// src/layouts/Pages/PageHeader/CardHeaderColumns/items/im.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { AuditOutlined, FileTextOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';
import { returnOnlyNumbers } from 'utils/helpers';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const imItem = record => {
  const im = record?.fiscalData?.municipalRegistration;

  return {
    key: 'im',
    icon: <AuditOutlined />,
    label: im || translateX('n_a'),
    tooltipText: translateX('municipal_registration'),
    tooltipPlacement: 'right',
    onClick: im ? () => appService.handleCopyToClipboard(returnOnlyNumbers(im), 'im_copied') : null,
  };
};

export default imItem;
